module.exports = __webpack_public_path__ + "img/bq.fbe3615e.svg";